import XInput from './Input.vue'
export default XInput